import { FetchRequestActions, SuccessFetchingAction } from "../../../../utils/request-actions-helpers/createRequestActions"
import { GetPredecessorsAdditionalData, getPredecessorsForDocumentActionTypes } from "./getPredecessorsDocument"

export type DocumentPredecessorsState = string[]

export interface PredecessorsState {
    data: {
        [docId: string]: DocumentPredecessorsState | undefined
    }
}

export const initialPredecessorsState: PredecessorsState = {
    data: {}
}

export const predecessorsReducer = (state: PredecessorsState = initialPredecessorsState, action: FetchRequestActions<string[], GetPredecessorsAdditionalData>): PredecessorsState => {
    switch (action.type) {
        case getPredecessorsForDocumentActionTypes.success: {
            const successAction = action as SuccessFetchingAction<string[], GetPredecessorsAdditionalData>
            if (!successAction.additionalData) {
                return state
            }
            const docId = successAction.additionalData.docId
            const newState: PredecessorsState = {
                data: {
                    ...state.data,
                    [docId]: successAction.result
                }
            }
            return newState
        }
        default:
            return state
    }
}